import { render, staticRenderFns } from "./BulkExchange.vue?vue&type=template&id=6f97f122&scoped=true"
import script from "./BulkExchange.vue?vue&type=script&lang=js"
export * from "./BulkExchange.vue?vue&type=script&lang=js"
import style0 from "./BulkExchange.vue?vue&type=style&index=0&id=6f97f122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f97f122",
  null
  
)

export default component.exports